var lib_core  = require("lib-core");

var OptionsModel        = require("./optionsModel.js");
var OptionsStateMachine = require("./optionsStateMachine.js");
var OptionsView         = require("./optionsView.js");

var InspectorController = require("./../inspector/inspectorController.js");
var TabController = require("./../tab/tabController.js");

var OptionsController = function(archLayers, dependencies, configuration) {
    InspectorController.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        OPTIONS_TOGGLE: {id: 'opt_0', name: "OPTIONS_TOGGLE", isGuiButton: true },
        OPTIONS_FOCUS: {id: 'opt_1', name: "OPTIONS_FOCUS" },
        OPTIONS_BLUR : {id: 'opt_2', name: "OPTIONS_BLUR" },
        OPTIONS_ENTER: {id: 'opt_3', name: "OPTIONS_ENTER"},
        OPTIONS_CHANGE_PROPERTY: {id: 'opt_4', name: "OPTIONS_CHANGE_PROPERTY" }
    });

    this.events = {
        changeProperty : lib_core.GuiEvents.OPTIONS_CHANGE_PROPERTY,
        focus: lib_core.GuiEvents.OPTIONS_FOCUS,
        enter: lib_core.GuiEvents.OPTIONS_ENTER,
        blur: lib_core.GuiEvents.OPTIONS_BLUR
    };
};
lib_core.inherit(OptionsController, InspectorController);
OptionsController.inject = lib_core.clone(InspectorController.inject);
OptionsController.inject.tabController = TabController;

module.exports = OptionsController;

OptionsController.prototype.createStateMachine = function () {
    return new OptionsStateMachine(this.root, this.getModel(), this.events);
};

OptionsController.prototype.createView = function () {
    var editorView = this.editorController.getView();
    var editorModel = this.editorController.getModel();
    return new OptionsView(this.getModel(), this.getStatemachine(), editorModel, editorView, this.tabController.getView(), this.rootStateMachine, this.configuration, this.events);
};

OptionsController.prototype.createModel = function () {
    return new OptionsModel(this.configuration);
};

OptionsController.prototype.afterLoad = function() {
    var self = this;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    this.masterController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};

OptionsController.prototype.setTitle = function (title) {
    this.getModel().title(title);
};

OptionsController.prototype.addOption = function (option) {
    this.getModel().options.push(option);
};

OptionsController.prototype.addOptionGroup = function (optionGroup) {
    var self = this;
    optionGroup.forEach(function (option) {
        self.addOption(option);
    });
};

